import { Model } from 'pinia-orm';
import Application from './Application';
import Competence from './Competence';
import CompetenceTag from './CompetenceTag';
import Job from './Job';
import Taggable from "./Taggable";


export default class Tag extends Model {
    static get entity () {
        return 'tags'
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr(''),
            application_count: this.number(0),
            competence_count: this.number(0),
            job_count: this.number(0),
            used: this.boolean(false),
            competences: this.belongsToMany(Competence, CompetenceTag, 'tag_id', 'competence_id'),
            jobs: this.morphedByMany(Job, Taggable, 'tag_id', 'taggable_id', 'taggable_type'),
            applications: this.morphedByMany(Application, Taggable, 'tag_id', 'taggable_id', 'taggable_type'),
        }
    }
}
